'use client'
import Head from 'next/head'
import styles from '@/styles/main.css'
import error from '@/styles/error.css'
import Footer from '@/components/Footer'
const Codes = {
	301: "Moved Permanently",
	307: "Temporary Redirect",
	400: "Bad Request",
	401: "Unauthorized",
	403: "Forbidden",
	404: "Page Not Found",
	500: "Internal Server Error",
	502: "Bad Gateway",
	503: "Service Unavailable",
	504: "Gateway Timeout"
}

export default function Error({ statusCode }) {
	console.log(statusCode)
	if (Codes[statusCode]) {
		var CodeDescription = Codes[statusCode]
	} else {
		var CodeDescription = "An Unknown Error Has Occurred."
	}
	return (<>
	  	<Head>
			<title>{statusCode}</title>
		</Head>
		<div className='next-error-Div1'>
			<div className="next-error-Div2">
				<h1 className="next-error-h1">
					{statusCode ? statusCode : "404"}
				</h1>
				<div className='next-error-Div3'>
					<h2 class="next-error-h2">{CodeDescription}</h2>
				</div>
			</div>
		</div>
	</>
	)
  }